import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 20px;
  color: rgb(40, 45, 55);
  margin: 20px 0;
  letter-spacing: -0.1px;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding-bottom: 10%;
`;

export default Container;
